<div class="folder">
  <input type="text" (keyup.enter)="saveFolder()" #input class="form-control folder-input" [(ngModel)]="folderName" placeholder="New Folder Name"/>
  <div class="folder-menu">
    <span (click)="cancelCreateFolder()" class="fa fa-times-circle-o fa-2x"></span>
    <span (click)="saveFolder()" [ngClass]="{'disabled' : !folderName}" class="fa fa-check-circle fa-2x"></span>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-list/create-folder/create-folder.component.html